import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Option } from 'src/app/model/common/option';
@Injectable()
export class AreaOperativaService {


  constructor(private http: HttpClient) { }

  getAreaOperativa() {
    return this.http.get<Option[]>('/assets/mocks/area-operativa.json');
  }

}
